import { render, staticRenderFns } from "./VendorServiceList.vue?vue&type=template&id=e44a0878&"
import script from "./VendorServiceList.vue?vue&type=script&lang=js&"
export * from "./VendorServiceList.vue?vue&type=script&lang=js&"
import style0 from "./VendorServiceList.vue?vue&type=style&index=0&id=e44a0878&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports